import React from 'react'

const FeatureCard = ({ title, description, imgSrc, imgAlt }) => {
    return (
        <div className="flex flex-col gap-5 w-full items-center">
            <div className="flex items-center justify-center p-2 rounded-full bg-[#A4D6B4] w-fit">
                <div className="flex items-center justify-center p-2 rounded-full bg-[#1C9943]">
                    <img src={imgSrc} alt={imgAlt} />
                </div>
            </div>
            <div className="flex flex-col gap-2">
                <span className="text-[#101828] text-xl font-bold text-center">
                    {title}
                </span>
                <p className="text-base text-[#475467] text-center">
                    {description}
                </p>
            </div>
        </div>
    )
}

const Features = () => {
    return (
        <div className='grid lg:grid-cols-3 gap-[32px] sm:py-[96px] py-[48px] px-[5.8vw] sm:grid-cols-2 grid-cols-1 max-w-[1980px] w-full'>
            <FeatureCard
                title="Look Deep Into your health"
                description="The side effect of exercise is mental development and of course, burning body-fat. The combination of a challenging exercise routine and a balanced meal plan is the best known way to lose fat."
                imgSrc="images/pulse.png"
                imgAlt="Pulse Icon"
            />
            <FeatureCard
                title="Adopt a Healthier Lifestyle"
                description="The first thing that clients tell me after starting an exercise program is how much better they feel. Most didn’t even realize how bad they felt. -It’s easy to get used to feeling sluggish, achy and unmotivated."
                imgSrc="images/dumbBell.png"
                imgAlt="Dumb Bell Icon"
            />
            <FeatureCard
                title="Improved mental-Wellbeing"
                description="A positive mindset for life’s experiences and the ability to learn and grow intellectually achieving the best mentality to create a perfect- healthy- body."
                imgSrc="images/mentalHealth.png"
                imgAlt="Mentel Health Icon"
            />
        </div>
    )
}

export default Features
